<template>
    <div class="tasks_row_body" @click="tabTask(task._id)" style="margin-bottom: 6px;">
        <router-link
            :to="linkToTask(task._id)"
            class="tasks_row"
            :class="task_class"
            :id="`task_${task._id}`"
            @click="fetch_comments({task_id: task._id, project_id: task.project_id})"
        >
            <h4 class="task_title" :id="task.local_id">
                {{ task.name }}
            </h4>

            <div style="display: flex; height: 100%;">

                <!-- <div class="task__subtask" @click.prevent="addSubTask(task._id)">
                    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.49897 5.08594H4.91564V0.502604C4.91564 0.392097 4.87174 0.286117 4.7936 0.207976C4.71546 0.129836 4.60948 0.0859375 4.49897 0.0859375C4.38846 0.0859375 4.28248 0.129836 4.20434 0.207976C4.1262 0.286117 4.0823 0.392097 4.0823 0.502604V5.08594H-0.501029C-0.611536 5.08594 -0.717517 5.12984 -0.795657 5.20798C-0.873797 5.28612 -0.917696 5.3921 -0.917696 5.5026C-0.919752 5.55676 -0.910176 5.61072 -0.889614 5.66086C-0.869053 5.711 -0.837982 5.75615 -0.798497 5.79326C-0.759012 5.83038 -0.71203 5.8586 -0.660716 5.87602C-0.609403 5.89345 -0.554951 5.89967 -0.501029 5.89427H4.0823V10.5026C4.0823 10.6131 4.1262 10.7191 4.20434 10.7972C4.28248 10.8754 4.38846 10.9193 4.49897 10.9193C4.60948 10.9193 4.71546 10.8754 4.7936 10.7972C4.87174 10.7191 4.91564 10.6131 4.91564 10.5026V5.91927H9.49897C9.60948 5.91927 9.71546 5.87537 9.7936 5.79723C9.87174 5.71909 9.91564 5.61311 9.91564 5.5026C9.91564 5.3921 9.87174 5.28612 9.7936 5.20798C9.71546 5.12984 9.60948 5.08594 9.49897 5.08594Z" fill="#000"/>
                    </svg>
                    <p>SUBTASK</p>
                </div> -->

                <div class="task__priority">
                    <div class="task__priority__title" 
                        @click.prevent="openPriorityMenu"
                        :style="`background-color: ${priority_color == 'transparent' ? '#f3f3f3' : priority_color}; color: ${priority_color == 'transparent' ? '#898989' : priority_color == '#F4F915' || priority_color == '#f3f3f3' ? '#000' : '#fff'}`"
                    >
                        <p>{{priority_text}}</p>
                        <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.57221 0.99729C0.705674 0.997029 0.835015 1.04351 0.937781 1.12867L3.99944 3.68766L7.06681 1.22006C7.12523 1.17261 7.19246 1.13718 7.26463 1.1158C7.33679 1.09442 7.41247 1.08751 7.48732 1.09547C7.56216 1.10343 7.6347 1.12611 7.70075 1.16219C7.7668 1.19828 7.82507 1.24706 7.87221 1.30574C7.91965 1.36417 7.95509 1.4314 7.97647 1.50356C7.99785 1.57573 8.00476 1.65141 7.99679 1.72625C7.98883 1.8011 7.96616 1.87363 7.93007 1.93968C7.89399 2.00573 7.8452 2.064 7.78653 2.11114L4.3593 4.87006C4.25709 4.95407 4.12889 5 3.99658 5C3.86428 5 3.73607 4.95407 3.63387 4.87006L0.20664 2.01403C0.1488 1.96608 0.10099 1.90719 0.0659451 1.84073C0.0309005 1.77427 0.00931025 1.70156 0.00241232 1.62674C-0.00448513 1.55193 0.00344515 1.47649 0.0257473 1.40474C0.0480499 1.333 0.0842862 1.26635 0.132383 1.20864C0.185535 1.14311 0.252544 1.09017 0.328592 1.05363C0.404641 1.01709 0.48784 0.997848 0.57221 0.99729Z" :fill="priority_color == 'transparent' ? '#898989' : priority_color == '#F4F915' || priority_color == '#f3f3f3' ? '#000' : '#fff'"/>
                        </svg>
                    </div>
                    <div class="task__priority__lists" v-if="show_menu">
                        <div class="task__priority__list" style="background-color: #f3f3f3; color: #000" v-if="priority_text != $t('task.priority.normal')" @click.prevent="priorityChange('#f3f3f3', 'Normal')">
                            {{ $t('task.priority.normal') }}
                        </div>
                        <div class="task__priority__list" style="background-color: #F4F915; color: #000000" v-if="priority_text != $t('task.priority.medium')" @click.prevent="priorityChange('#F4F915', 'Medium')">
                            {{ $t('task.priority.medium') }}
                        </div>
                        <div class="task__priority__list" style="background-color: #F12E2E" v-if="priority_text != $t('task.priority.high')" @click.prevent="priorityChange('#F12E2E', 'High')">
                            {{ $t('task.priority.high') }}
                        </div>
                    </div>
                </div>

                <div class="task__date" v-if="task.assign && task.assign.date">
                    <span v-if="assign_date">
                        <p v-if="assign_date == 'Today' || assign_date == 'Yesterday'" style="color: #FF8686">{{enumAssign[assign_date] ? enumAssign[assign_date] : assign_date}}</p>
                        <p v-else style="color: #489CDC">{{enumAssign[assign_date] ? enumAssign[assign_date] : assign_date}}</p>
                    </span>
                    <span v-else>
                        <p v-if="assignDate(task.assign.date) == 'Today' || assignDate(task.assign.date) == 'Yesterday'" style="color: #FF8686">{{enumAssign[assignDate(task.assign.date)] ? enumAssign[assignDate(task.assign.date)] : assignDate(task.assign.date)}}</p>
                        <p v-else style="color: #489CDC">{{enumAssign[assignDate(task.assign.date)] ? enumAssign[assignDate(task.assign.date)] : assignDate(task.assign.date)}}</p>
                    </span>
                </div>

                <div class="mtb-auto" v-if="get_unreaded_messages_in_tasks[task._id] > 0">
                    <span v-if="get_unreaded_messages_in_tasks[task._id] > 0" class="unread_messages">
                        {{ get_unreaded_messages_in_tasks[task._id] }}
                    </span>
                </div>
                
                <!-- <div v-if="task.assign && task.assign.user_id || check_assign">
                    <div class="task__priority__assign_to" :style="`background-color: ${priority_color == 'transparent' ? '#DDDDDD' : priority_color};`">
                        <span :style="`color: ${priority_color == 'transparent' ? '#898989' : priority_color}`" v-if="assign_name">
                            {{assign_name}}
                        </span>
                        <span :style="`color: ${priority_color == 'transparent' ? '#898989' : priority_color}`" v-else>
                            {{userName_Assign(task.assign.user_id)}}
                        </span>
                    </div>
                </div> -->

                <div v-if="task.assign && task.assign.user_id || check_assign">
                    <div class="task__priority__assign_to">
                        <span :style="`border: 1px solid ${userName_Assign(task.assign.user_id).color};color: ${userName_Assign(task.assign.user_id).color}`" v-if="assign_name" v-html="$w_user_image(assign_name, 70, false)"></span>
                        <span :style="`border: 1px solid ${userName_Assign(task.assign.user_id).color};color: ${userName_Assign(task.assign.user_id).color}`" v-else v-html="$w_user_image(userName_Assign(task.assign.user_id), 70, false)"></span>
                    </div>
                </div>

                <div class="task__priority-line" :style="`background-color: ${priority_color};${priority_text != $t('task.priority.normal') ? 'opacity: 1;' : 'opacity: 0;'}`"></div>

            </div>

        </router-link>
        <el-checkbox v-model="task.done" @input="change_complete"></el-checkbox>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import RenameElement from "@/components/app/RenameElement";
// import SubTask from './SubTask.vue'
import {EventEmitter} from '../../main'
import File from '../../utils/aws'
import draggable from "vuedraggable";

export default {
  name: "Task",
  props: {
    task: {
      type: Object,
      required: true,
    },
    done: [Boolean],
    search: [Boolean],
    chat_id: [String]
  },
  data() {
    return {
      task_class: "",
      show_menu: false,
      priority_color: 'transparent',
      priority_text: this.$t('task.priority.normal'),
      assign_name: '',
      subtasks: [],
      subtasks_done: [],
      this_user_change_order: true,
      this_user_change_done: true,
      show_subtask: false,
      assign_date: '',
      check_assign: '',
      done_show: true,
      project_id: '',
      enumAssign: {
        Today: this.$t('task.assign.today'),
        Yesterday: this.$t('task.assign.yesterday'),
        Tomorrow: this.$t('task.assign.tomorrow')
      }
    };
  },
  async mounted() {

    this.project_id = this.task.project_id

    let localShow_subtask = localStorage.getItem(this.task._id)
    this.show_subtask = localShow_subtask == 'false' ? false : true
    
    if (this.getSubTask) {
        if (this.subtasks.length == 0) {
            let sub = []
            this.getSubTask.forEach((e, i) => {
                if (e.parent == this.task._id) {
                    sub[e.order] = e
                }
            })
            let filtered = sub.filter(function (el) {
                return el != null
            })
            this.subtasks = filtered
        }
    }

    // EventEmitter.$on('OutAssignUserName', (data) => {
    //     console.log(data)
    //     this.assign_name = data[0]
    // })

    this.priority_text = this.task.priority ? this.task.priority : 'Normal'

    if (this.priority_text == 'Normal') {
        this.priority_color = '#f3f3f3'
    } else if (this.priority_text == 'Medium') {
        this.priority_color = '#F4F915'
    } else if (this.priority_text == 'High') {
        this.priority_color = '#F12E2E'
    }

    this.task_class = this.task.done ? "tasks_row_completed" : "";
    EventEmitter.$on('Priority', (data) => {
        if (data.task_id == this.task._id) {
            const enumPriority = {
                Normal: this.$t('task.priority.normal'),
                Medium: this.$t('task.priority.medium'),
                High: this.$t('task.priority.high')
            }
            this.priority_text = enumPriority[data.priority]
            if (data.priority == 'Normal') {
                this.priority_color = '#f3f3f3'
            } else if (data.priority == 'Medium') {
                this.priority_color = '#F4F915'
            } else if (data.priority == 'High') {
                this.priority_color = '#F12E2E'
            }
        }
    })

    EventEmitter.$on('AssignDate', (data) => {
        if(data.date){
            if (data.task_id == this.task._id) {
                this.assign_date = this.assignDate(data.date)
            }
        }else{
            this.assign_date = this.assignDate('')
        }
        
    })

    EventEmitter.$on('changeOrder', (data) => {
        if (data) {
            if (this.this_user_change_order) {
                let arr = []
                // this.subtasks = []
                data.new_order.forEach((a, i) => {
                    this.subtasks.forEach((e) => {
                        if (e.parent == this.task._id) {
                            if (e._id == a.task_id) {
                                arr[a.order] = e
                            } else {
                                arr[e.order] = e
                            }
                        }
                    })
                })
                let filtered = arr.filter(function (el) {
                    return el != null;
                });
                this.subtasks = []
                this.subtasks = filtered
            }else{
                this.this_user_change_order = true
            }
        }
    })

    let off = true
    EventEmitter.$on('offAddSubTask', (data) => {
        off = data
        // this.checkSubTask_in_Task(this.task._id)
    })

    EventEmitter.$on('addSubTask', (data) => {
        if (off) {
            if (data.parent == this.task._id) {
                this.subtasks.push(data)
            }
        }
    })

    setTimeout(() => {
        if (document.querySelector('.avatar_img')) {
            document.querySelectorAll('.avatar_img').forEach((e) => {
                e.parentNode.classList.add("avatar_img_span")
            })
        }
    }, 10)

    EventEmitter.$on('AssignUser', (data) => {
        if(data.user_id){
            if (data.task_id == this.task._id) {
                if(this.getUserData._id == data.user_id){
                    this.assign_name = this.getUserData.name[0]
                }else{
                    this.getKnownUsers.forEach((e) => {
                        if(e._id == data.user_id) {
                            this.assign_name = e.name[0]
                        }
                    })
                }
                this.check_assign = true
            }
        }else{
            if (data.task_id == this.task._id) {
                this.task.assign.user_id = false
            }
            this.assign_name = "";
            this.check_assign = false
        }
    })

    EventEmitter.$on('change_completes', (data) => {
        if (data.task_id == this.task._id) {
            this.show_subtask = data.show
            localStorage.setItem(this.task._id, data.show)
        }
    })

    EventEmitter.$on('SubTaskDone', (data) => {
        if (this.this_user_change_done) {
            let task_id = data.task_id
            this.subtasks.forEach((e, i) => {
                if (e._id == task_id) {
                    this.subtasks[i].done = data.done
                    // this.subtasks = this.subtasks
                }
            })
            // let task_id = data.task_id
            // let done = this.subtasks_done.filter((e) => e._id == task_id)
            // let undone = this.subtasks.filter((e) => e._id == task_id)

            // if (done.length > 0) {
            //     this.subtasks_done.forEach((e, i) => {
            //         if (e._id == task_id) {
            //             this.subtasks_done.splice(i, 1)
            //             // this.subtasks.push(e)
            //             let task = this.subtasks
            //             task.push(e)
            //             this.subtasks = task
            //         }
            //     })
            // }

            // if (undone.length > 0) {
            //     this.subtasks.forEach((e, i) => {
            //         if (e._id == task_id) {
            //             this.subtasks.splice(i, 1)
            //             // this.subtasks_done.unshift(e)
            //             let task = this.subtasks_done
            //             task.unshift(e)
            //             this.subtasks_done = task
            //         }
            //     })
            // }
        }else{
            this.this_user_change_done = true
        }
    })

  },
  methods: {
    ...mapActions([
      "socket_completed_task",
      "socket_delete_task",
      "socket_rename_task",
      "socket_change_order"
    ]),
    ...mapMutations([
      "setUserFileSize_minus"
    ]),
    checkSubTask_in_Task (task_id) {
        let tasks = this.subtasks
        let bool = false
        tasks.forEach((e) => {
            if (e.parent == task_id) {
                bool = true
            }
        })
        return bool
    },
    checkAssignTo (assign_name, user_id) {
        // let tasks = this.getTasks[this.project_id]
        // tasks.forEach((task) => {
        //     if (task._id == task_id) {
        //         if (task.assign.user_id) {
        //             return true
        //         }
        //     }
        // })
        // console.log(assign_name, user_id)
        // if (task_id == this.task._id) {
            if (assign_name || user_id) {
                return true
            } else {
                return false
            }
        // }
    },
    checkSubTaskDone (task_id) {
        let tasks = this.subtasks
        let bool = false
        tasks.forEach((e) => {
            if (e.parent == task_id) {
                if (e.done) {
                    bool = true
                }
            }
        })
        return bool
    },
    openSubTask() {
        this.show_subtask = !this.show_subtask
        localStorage.setItem(this.task._id, this.show_subtask)
    },
    // fill_tasks_array(getSubTask) {
    //     // this.subtask = []
    //     const tasks = getSubTask

    //     if (tasks) {
    //         tasks.forEach((e, i) => {
    //             if (e.parent == this.task._id) {
    //                 this.subtasks[e.order] = {}
    //                 if (this.subtasks[e.order]) {
    //                     this.subtasks[e.order] = e
    //                 }
    //             }
    //         })
    //     }
    // },
    change_complete_sub({ complete, task_id }) {
        // const new_order_position = {
        //     out: true,
        //     new_order: this.$w_change_order(
        //         "done",
        //         this.subtasks,
        //         {
        //             complete,
        //             task_id,
        //         }
        //     ),
        //     project_id: this.project_id,
        // };
        // EventEmitter.$emit('change_complete', {
        //     task_id: task_id,
        //     show: true
        // })
        // let done = this.subtasks_done.filter((e) => e._id == task_id)
        // let undone = this.subtasks.filter((e) => e._id == task_id)

        // if (done.length > 0) {
        //     this.subtasks_done.forEach((e, i) => {
        //         if (e._id == task_id) {
        //             this.subtasks_done.splice(i, 1)
        //             // this.subtasks.push(e)
        //             let task = this.subtasks
        //             task.push(e)
        //             this.subtasks = task
        //         }
        //     })
        // }

        // if (undone.length > 0) {
        //     this.subtasks.forEach((e, i) => {
        //         if (e._id == task_id) {
        //             this.subtasks.splice(i, 1)
        //             // this.subtasks_done.unshift(e)
        //             let task = this.subtasks_done
        //             task.unshift(e)
        //             this.subtasks_done = task
        //         }
        //     })
        // }

        this.subtasks.forEach((e, i) => {
            if (e._id == task_id) {
                this.subtasks[i].done = complete
            }
        })

        this.socket_completed_task({
            complete,
            bool: true,
            task_id: task_id,
            project_id: this.project_id,
        });
        this.this_user_change_done = false
        setTimeout(() => {
            let tasks = this.subtasks
            let new_order = []

            tasks.forEach((e, i) => {
                new_order.push({
                    task_id: e._id,
                    order: i
                })
            })
            // if (evt.newIndex == evt.oldIndex) return;

            const new_order_position = {
                out: true,
                new_order: new_order,
                project_id: this.project_id,
            };
            // this.socket_change_order({ new_order_position, add_global: true });
        }, 100);
    },
    onEndTaskDrop(evt) {
        let tasks = this.subtasks
        let new_order = []

        tasks.forEach((e, i) => {
            new_order.push({
                task_id: e._id,
                order: i
            })
        })
        // if (evt.newIndex == evt.oldIndex) return;

        const new_order_position = {
            out: true,
            new_order: new_order,
            project_id: this.project_id,
            evt: evt
        };
        this.this_user_change_order = false
        this.socket_change_order({ new_order_position, add_global: true });
    },
    addSubTask (task_id) {

        const subtask = this.subtasks
        let stop = false
        subtask.forEach((e) => {
            if (e.parent == task_id) {
                if (e.name == '') {
                    stop = true
                }
            }
        })

        if (stop) {
            return
        }

        this.show_subtask = true
        let order = []

        if (subtask.length > 0) {
            subtask.forEach((e) => {
                if (task_id == e.parent) {
                    order.push(e.order)
                }
            })
        } else {
            order = 0
        }

        this.subtasks.push({
            assign: {
                user_id: ''
            },
            name: '',
            project_id: this.project_id,
            order: order == 0 ? 1 : Math.max.apply(null, order) + 1,
            parent: task_id,
            _id: this.$w_decrypt(this.getUserData._id),
        })

        setTimeout(() => {
            document.querySelector('.task__input-name input').focus()
        }, 500)

    },
    assignDate (date) {
        if (date) {

            if (!isNaN(date)) {
                date = new Date(+date).toISOString()
            }
            
            const today = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate()
            ).getTime()

            const yestarday = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate() - 1
            ).getTime()

            const tomorrow = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate() + 1
            ).getTime()

            const date_from_comment = new Date(
                new Date(date).getFullYear(),
                new Date(date).getMonth(),
                new Date(date).getDate()
            ).getTime()

            if (date_from_comment == today) { return "Today" }
            else if (date_from_comment == yestarday) { return "Yesterday" }
            else if (date_from_comment == tomorrow) { return "Tomorrow" }
            else {
                if (new Date().getFullYear() == new Date(date).getFullYear()) {
                    return new Intl.DateTimeFormat("en-GB", {
                        day: "numeric",
                        month: "short",
                    }).format(new Date(date))
                } else {
                    return new Intl.DateTimeFormat("en-GB", {
                        day: "numeric",
                        month: "short",
                    }).format(new Date(date)) + ', ' + new Date(date).getFullYear()
                }
            }
        }
    },
    userName_Assign (user_id) {
        const users = this.getKnownUsers
        let name
        if (this.getUserData._id == user_id) {
            name = this.getUserData
        } else {
            users.forEach((e) => {
                if (e._id == user_id) {
                    name = e
                }
            })
        }
        return name
    },
    priorityChange (color, text) {
        const enumPriority = {
            Normal: this.$t('task.priority.normal'),
            Medium: this.$t('task.priority.medium'),
            High: this.$t('task.priority.high')
        }
        this.priority_color = color
        this.priority_text = enumPriority[text]
        this.show_menu = !this.show_menu
        this.$socket.emit('IN_Priority', {
            task_id: this.task._id,
            project_id: this.project_id,
            priority: text,
            author: JSON.stringify({name: this.getUserData.name, id: this.getUserData._id})
        })
    },  
    openPriorityMenu () {
        this.show_menu = !this.show_menu
    },
    tabTask: function (task_id) {
        EventEmitter.$emit('Note_Size', task_id)
        // Проверяем vuex getAssigns есть ли там данные 
        let send_data = true
        this.getAssigns.forEach(e => {
            if(e.task_id == this.$route.params.task_id) {
                
                setTimeout(() => {
                    send_data = false
                    if (e.user_id) {
                        let data = {
                            assign: e,
                            update: false
                        }
                        EventEmitter.$emit('AssignFind', data)
                    }else{
                        e.user_id = ''
                        let data = {
                            assign: e,
                            update: false
                        }
                        EventEmitter.$emit('AssignFind', data)
                    }
                }, 100);
                // EventEmitter.$emit('AssignUser', data)
            }
        })
        // Если нет данных то мы отправляем данные в бек
        if(send_data){
            // this.$socket.emit('IN_AssignFind', {
            //     task_id: task_id
            // })
        }
        // const assign = this.getAssigns.find((e) => e.task_id == task_id)
        // if(assign){
        //     console.log(assign)
        // }else{
        //     console.log(this.$store.state.getAssigns)
        //     // this.$on('AssignFind', (data) => {
        //     //     console.log(data)
        //     // })
        // }
    },
    linkToTask(task_id) {
         setTimeout(() => {
            if (document.querySelector('.right_col_sidebar')) {
                document.querySelector('.right_col_sidebar').classList.add('run_anime')
            }
        }, 10)
        // localStorage.setItem('project_id', this.project_id)
        return `/shortcuts/${this.$route.params.shortcuts}/project/${this.task.project_id}/task/${task_id}`;
        // if (this.chat_id) {
        //     return `/chats/${this.chat_id}/task/${task_id}`;
        // } else {
        //     return `/project/${this.task.project_id}/task/${task_id}`;
        //     // return `/project/${this.$route.params.project_id}/task/${task_id}`;
        // }
    },
    change_complete() {
        this.$emit("change_complete", {
            complete: this.task.done,
            task_id: this.task._id,
            project_id: this.task.project_id
        })
    },
    deleteTask(task) {
        let body_to_del = {
            project_id: this.project_id,
            task_id: task._id,
            task_file_size: task.file_size,
        };
        this.$emit("delete_task", body_to_del);
        if (
            this.$route.params.task_id &&
            this.$route.params.task_id == task._id
        ) {
            this.$router.push(`/project/${this.project_id}`);
        }
        const comments = this.getComments[task._id]
        comments.forEach((e) => {
            e.files.forEach((f) => {
                this.setUserFileSize_minus(+f.size)
            })
        })
        this.socket_delete_task(body_to_del);
        const aws = new File()
        const remove = aws.removeFolder('Lists' + '/' + this.project_id + '/' + task._id + '/')
    },
  },
  computed: {
    ...mapGetters([
      "get_flag_for_unreaded",
      "get_unreaded_messages_in_tasks",
      "get_active_task_window",
      "getTasks",
      "getAssigns",
      "getComments",
      "getKnownUsers",
      "getUserData",
      "getSubTask",
      "get_flag_for_tasks",
      "get_flag_for_add_task",
      "getRenderKnownUsers",
      "getRenderUserData"
    ]),
    getTaskDone() {
      return this.done;
    },
    dragOptions() {
        return {
            animation: 200,
            group: "description",
            disabled: false,
            ghostClass: "ghost"
        };
    },
    // nested_tasks: {
    //   get() {
    //     return this.subtasks;
    //   },
    //   set(value) {
    //     console.log("nested_tasks", value);
    //   },
    // },
  },
  watch: {
    getTaskDone(e) {
      this.task_class = e ? "tasks_row_completed" : "";
    },
    getRenderKnownUsers() {
        setTimeout(() => {
            if (document.querySelector('.avatar_img')) {
                document.querySelectorAll('.avatar_img').forEach((e) => {
                    e.parentNode.classList.add("avatar_img_span")
                })
            }
        }, 500);
    },
    getRenderUserData() {
        setTimeout(() => {
            if (document.querySelector('.avatar_img')) {
                document.querySelectorAll('.avatar_img').forEach((e) => {
                    e.parentNode.classList.add("avatar_img_span")
                })
            }
        }, 500)
    }
    // assign_name(e) {
    //     console.log('==================')
    //     console.log(e)
    //     console.log('==================')
    // }
    // get_flag_for_tasks() {
    //     // this.fill_tasks_array(this.subtasks);
    //     // this.subtasks.forEach((e) => {
    //     //     console.log(e.name, e.order)
    //     // })
    // },
    // $route(to) {
    //     this.subtasks = [];
    //     this.fill_tasks_array(this.getSubTask);
    // },
  },
  components: {
    RenameElement,
    // SubTask,
    draggable
  },
};

/* 
(typeof task._id == 'number'
          ? getTasks[$route.params.project_id].find((t) => t.local_id == task._id)._id
          : task._id)
*/
</script>
